// extracted by mini-css-extract-plugin
export default {"reason":"ReportAdReason-module__reason___1Mo6T"};